import React, { useState, useEffect, useRef, useMemo } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TablePagination from '@mui/material/TablePagination';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import SendIcon from '@mui/icons-material/Send';
import IconButton from '@mui/material/IconButton';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import DeleteIcon from '@mui/icons-material/Delete';
import Checkbox from '@mui/material/Checkbox';
import Tooltip from '@mui/material/Tooltip';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import DownloadIcon from '@mui/icons-material/Download';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import {
  Grid,
  Card,
  CardHeader,
  CardContent,
  Typography,
  Box,
  Stack,
} from '@mui/material';
import dayjs from 'dayjs';
import _, { isEmpty, set } from 'lodash';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Swal from 'sweetalert2';
import Loading from '../Loading';
import '../../custom.css';
import { addCommas } from '../../utils/functions/commas';
import DetailPayment from '../DetailPayment/DetailPayment';
import ReplayIcon from '@mui/icons-material/Replay';
import {
  initializeSocket,
  getSocket,
  disconnectSocket,
} from '../../components/Socket/SocketComponent';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import {
  swalErrorTimer,
  swalLoading,
  swalSuccessTimer,
  swalSuccessBtn,
  swalErrorBtn,
  swalConfirm,
  swalConfirmEmail,
  swalClose,
} from '../../helpers/swalHelper';
import utc from 'dayjs/plugin/utc';
import InvoiceListApi from '../../service/invoice.api';
import NotifyListApi from '../../service/notify.api';
import ManualPaidDialog from '../dialogs/Invoice/ManualPaidDialog';
import PreviewPdfDialog from '../dialogs/Invoice/PreviewPdfDialog';
import QrCodeDialog from '../dialogs/Invoice/QrCodeDialog';
import LinearLoading from '../LinearLoading';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import VerifiedIcon from '@mui/icons-material/Verified';
import DetailDialog from '../dialogs/Invoice/DetailDialog';
import EmailConfirmDialog from '../dialogs/Invoice/EmailConfirmDialog';
import { STATUS } from '../../utils/constants';
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';
import { delay } from '../../utils/functions/delay';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';

dayjs.extend(utc);

const ITEM_PER_PAGE = [5, 10, 25, 50, 100]

function TableInvoiceList({
  invoiceList,
  rowsPerPage,
  page,
  total,
  sort,
  setPage,
  setRowsPerPage,
  setSort,
  getInvoiceLists,
  havePdf,
  NoQrCode,
  isLinearLoading,
  manualPayment
}) {
  const [selectedRows, setSelectedRows] = useState([]);
  const [success, setSuccess] = useState(false);
  const timer = useRef();
  const [isLoading, setIsLoading] = useState(false);
  const [openDialogQr, setOpenDialogQr] = useState(false);
  const [openDetail, setOpenDetail] = useState(false);
  const [qrCode, setQrCode] = useState('');

  const [openDialogPDF, setOpenDialogPDF] = useState(false);
  const [showPdf, setShowPdf] = useState('');

  const [openDialogConfirmBarcode, setOpenDialogConfirmBarcode] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedDueDate, setSelectedDueDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);

  const [selectedOrderId, setSelectedOrderId] = useState('');
  const [inputError, setInputError] = useState({ date: false, time: false, timeFuture: false });

  const [anchorEl, setAnchorEl] = useState(null);

  const [openDialogDetail, setOpenDialogDetail] = useState(false);
  const [detailData, setDetailData] = useState();

  const [menuRowOrderId, setMenuRowOrderId] = useState(null);

  const [openDialogEmail, setOpenDialogEmail] = useState(false);
  const [sendMailStatus, setSendMailStatus] = useState(null);
  const [rowSelectedList, setRowSelectedList] = useState([]);

  const MAIL_BUTTON = {
    undefined: {
      color: 'primary',
      icon: <SendIcon />,
      disabled: false,
      label: 'ส่งอีเมล'
    },
    'none': {
      color: 'primary',
      icon: <SendIcon />,
      disabled: false,
      label: 'ส่งอีเมล'
    },
    'sent': {
      color: 'warning',
      icon: <ReplayIcon />,
      disabled: false,
      label: 'ส่งอีกครั้ง'
    },
    'pending': {
      color: 'primary',
      icon: <HourglassEmptyIcon />,
      disabled: true,
      label: 'กำลังส่ง'
    },
    'failed': {
      color: 'error',
      icon: <ReplayIcon />,
      disabled: false,
      label: 'ส่งอีกครั้ง'
    }
  }

  const open = Boolean(anchorEl);
  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  }

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const openDetailDialog = async (order_id) => {
    try {
      const data = await InvoiceListApi.getInvoiceDetail(order_id);
      const resp = data?.data

      setDetailData(resp)
      setOpenDialogDetail(true);
    } catch (error) {
      console.log('error');
      swalErrorTimer({ text: `ไม่สามารถแสดงข้อมูลได้ ! ${error}` });
    }
  };

  const closeDetailDialog = () => {
    setOpenDialogDetail(false);
  }

  const handleShowQrCode = async (id) => {
    // สามารถตั้งชื่ออะไรก็ได้เพื่อโยน _id เข้ามาใน (id)
    setIsLoading(true);
    try {
      const resp = await NotifyListApi.postQrCodeApi(id);
      setQrCode(resp?.QRpayment);

      setIsLoading(false);
      setOpenDialogQr(true);

      // setTimeout(() => {
      //   window.location.reload();
      // }, 3100);
    } catch (error) {
      console.error('Error ', error);
      // เพิ่มโค้ดที่คุณต้องการทำหลังจากเกิด error ในการเรียก API
      // setOpenDialogQr(true);
      swalErrorTimer({ text: `ไม่สามารถคัดลอกลิงก์ได้ ! ${error}` });
      setIsLoading(false);
    }
  };

   const handlePreviewPdf = async (order_id) => {
    swalLoading({ title: 'กำลังเปิดไฟล์ PDF...' });

    try {
      const resp = await InvoiceListApi.getPdfApi(order_id);

      const base64 = resp?.base64;
      const byteCharacters = atob(base64);
      const byteNumbers = new Array(byteCharacters.length).fill().map((_, i) => byteCharacters.charCodeAt(i));
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });
      const pdfUrl = URL.createObjectURL(blob);

      Swal.close();
      setShowPdf(pdfUrl);
      setOpenDialogPDF(true);

    } catch (error) {
      console.log('Error : ', error);
      swalErrorTimer({ text: `ไม่สามารถเปิดไฟล์ PDF ได้!` })
      setIsLoading(false);
    }
  };

  const handleDownloadPdf = () => {
    const link = document.createElement('a');
    link.href = showPdf;
    link.download = 'invoice.pdf';
    link.click();
  };

  const openDialogConfirm = () => {
    setOpenDialogConfirmBarcode(true);
  };

  const {
    reset,
    setValue
  } = useForm({
    resolver: yupResolver(),
  });

  const handleConfirmBarCode = async () => {
    try {
      let hasError = false;
      if (!selectedDueDate) {
        setInputError(prev => ({ ...prev, date: true }));
        hasError = true;
      } else {
        setInputError(prev => ({ ...prev, date: false }));
      }

      if (selectedDueDate) {
        const selectedDateOnly = dayjs(selectedDueDate).startOf('day');
        const today = dayjs().startOf('day');
        if (selectedDateOnly.isSame(today)) {
          if (selectedTime && selectedTime > dayjs()) {
            setInputError(prev => ({ ...prev, timeFuture: true }));
            hasError = true;
          } else {
            setInputError(prev => ({ ...prev, timeFuture: false }));
          }
        } else {
          setInputError(prev => ({ ...prev, timeFuture: false }));
        }
      }

      if (!selectedTime) {
        setInputError(prev => ({ ...prev, time: true }));
        hasError = true;
      } else {
        setInputError(prev => ({ ...prev, time: false }));
      }
      if (hasError) return;

      setOpenDialogConfirmBarcode(false);
      const res = await swalConfirm({title: 'ยืนยันการดำเนินการ?'});
      if(res.isConfirmed) {
          let payDateObj = null;
          if (selectedDueDate && selectedTime) {
            payDateObj  = `${dayjs(selectedDueDate).format('YYYY-MM-DD')} ${dayjs(selectedTime).format('HH:mm:ss')}`;
          }

        const payDate = payDateObj
          ? dayjs.utc(payDateObj, 'YYYY-MM-DD HH:mm:ss')
          : null;

        const resp = await InvoiceListApi.postManualPaidApi(selectedOrderId, payDate);
        swalSuccessTimer({title: 'บันทึกการชำระเรียบร้อย!'});

        reset();
        setSelectedDate(null);
        setSelectedDueDate(null);
        setSelectedTime(null);

        await getInvoiceLists();
        return resp;
      } else {
        setOpenDialogConfirmBarcode(true);
      }
    } catch (error) {
      console.log('Error :', error);
      swalErrorTimer({text: `ไม่สามารถบันทึกข้อมูลได้ !`});
    }
  };

  const handleCancel = () => {
    reset();
    setSelectedDate(null);
    setSelectedDueDate(null);
    setSelectedTime(null);
    setOpenDialogConfirmBarcode(false);
  };

  const copyTextToClipboard = async (id) => {
    try {
      // Fetch the link from the API
      const resp = await NotifyListApi.postGenLinkApi(id);

      // Extract the link from the response
      const link = resp?.link;
      if (!link) {
        throw new Error('No link found in the API response.');
      }

      // Copy the link to the clipboard
      if (navigator.clipboard) {
        await navigator.clipboard.writeText(link);
        swalSuccessTimer({title: 'ลิงก์ถูกคัดลอกสำเร็จ!'});
      } else {
        throw new Error('Clipboard API is not supported in this browser.');
      }

      // Return the copied link
      return link;
    } catch (error) {
      console.error('Error in copyTextToClipboard:', error);
      swalErrorTimer({text: `ไม่สามารถคัดลอกลิงก์ได้ กรุณาลองอีกครั้ง`});
    }
  };

  const styleStatusLate = {
    bgcolor: 'error.main',
    height: 30,
    width: 120,
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    borderRadius: 10,
    justifyContent: 'center',
    color: 'white',
  };
  const styleStatusNoLate = {
    bgcolor: 'primary.main',
    height: 30,
    width: 120,
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    borderRadius: 10,
    justifyContent: 'center',
    color: 'white',
  };
  const styleStatusLateCard = {
    bgcolor: 'error.main',
    height: 30,
    // width: 120,
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
  };
  const styleStatusNoLateCard = {
    bgcolor: 'primary.main',
    height: 30,
    // width: 120,
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
  };

  const handleSort = (column) => {
    if (sort.column === column) {
      setSort({
        ...sort,
        direction: sort.direction === 'asc' ? 'desc' : 'asc',
      });
      setPage(0);
    } else {
      setSort({ direction: 'asc', column });
      setPage(0);
    }
  };

  const handleOpenEmailDialog = (rowList) => {
    if(isEmpty(rowList)) {
      swalErrorBtn({ title: `โปรดเลือกข้อมูลก่อนส่งอีเมล` });
      return;
    }

    setRowSelectedList(rowList);
    setOpenDialogEmail(true);
  }

  const closeDialogEmail = () => {
    setOpenDialogEmail(false);
  }

  const handleSelectAllRows = (event) => {
    if (event.target.checked) {
      setSelectedRows(invoiceList);
    } else {
      setSelectedRows([]);
    }
  };

  const isSelected = (rowId) => selectedRows.some((row) => row._id === rowId);

  const handleSelectRow = (row) => {
    if (isSelected(row._id)) {
      setSelectedRows(selectedRows.filter((r) => r._id !== row._id));
    } else {
      setSelectedRows([...selectedRows, row]);
    }
  };

  const handleDeleteInv = async (id) => {
    try {
      const result = await swalConfirm({
        title: 'ยืนยันการลบรายการ?',
        icon: 'warning',
      });

      if (result.isConfirmed) {
        swalLoading({ title: 'กำลังลบข้อมูล...' });

        const resp = await InvoiceListApi.deleteByIdApi(id);

        Swal.close();
        if (resp.message === 'OK') {
          await swalSuccessBtn({ title: 'ลบรายการสำเร็จ' });
          getInvoiceLists();
        } else {
          swalErrorTimer({text: `ไม่สามารถลบรายการได้`});
        }

      } else if (result.isDenied) {
        swalErrorBtn({ title: 'ยกเลิกการลบรายการ' });
      }

    } catch (error) {
      swalErrorBtn({ title: 'ลบรายการไม่สำเร็จ' });
    }
  };

  const handleDeleteALL = async () => {
    if (isEmpty(selectedRows)) {
      swalErrorBtn({ title: `โปรดเลือกรายการก่อนลบข้อมูล` });
      return;
    }

    try {
      const result = await swalConfirm({
        title: `ยืนยันการลบ ${selectedRows.length} รายการ?`,
        icon: 'warning',
      });

      if (result.isConfirmed) {
        swalLoading({ title: 'กำลังลบข้อมูล...' });

        const resp = await InvoiceListApi.deleteManyApi(selectedRows);

        Swal.close();
        if (resp.message === 'OK') {
          await swalSuccessBtn({ title: 'ลบรายการสำเร็จ' });
          getInvoiceLists();
          setSelectedRows([]);
        } else {
          swalErrorBtn({ title: resp.message || 'เกิดข้อผิดพลาดขณะลบ' });
        }

      }

    } catch (error) {
      swalErrorBtn({ title: 'ลบรายการไม่สำเร็จ' });
    }
  };

  const toZipFile = async (blob) => {
      const url = window.URL.createObjectURL(new Blob([blob.data], { type: 'application/zip' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'invoices_pdf.zip');
      document.body.appendChild(link);
      link.click();
      link.remove();
      setTimeout(() => window.URL.revokeObjectURL(url), 2000);
  }

  const handleDownloadZipPDF = async (selectedRows) => {
    if (isEmpty(selectedRows)) {
      swalErrorBtn({ title: `โปรดเลือกข้อมูลก่อนดาวน์โหลด` });
      return;
    }

    const confirm = await swalConfirm({title: `ยืนยันการดาวน์โหลดไฟล์หรือไม่`});
    if (!confirm.isConfirmed) {
      return;
    }

    try {
      swalLoading({ title: 'กำลังดาวน์โหลดไฟล์...' });
      const selectedOrderIds = selectedRows.map(row => row.order_id);
      const resp = await InvoiceListApi.postZipPDFApi(selectedOrderIds);
      await toZipFile(resp);
    } catch (error) {
      console.error('Error:', error);
      swalErrorBtn({ title: `ดาวน์โหลดไม่สำเร็จ` });
    } finally {
      await delay(3000)
      swalClose();
    }
  };

  const isCheckboxAllChecked = useMemo(() => {
    if (selectedRows.length === 0) return false

    const isSelectedAll = invoiceList.every((invoice) => {
      return selectedRows.some((row) => row._id === invoice._id);
    })

    return isSelectedAll
  }, [selectedRows, invoiceList])

  useEffect(
    () => () => {
      clearTimeout(timer.current);
    },
    [],
  );

  useEffect(() => {
    closeDialogEmail()

    if (sendMailStatus === STATUS.SUCCESS) {
      swalSuccessBtn({title: 'ส่งอีเมล์สำเร็จ'}).then((result) => {
        if (result.isConfirmed) {
          setSelectedRows([]);
          getInvoiceLists()
        }
      })
      setSendMailStatus(null)
    } else if (sendMailStatus === STATUS.ERROR) {
      swalErrorBtn({title: `ส่งอีเมลไม่สำเร็จ`}).then((result) => {
        if (result.isConfirmed) {
          getInvoiceLists()
        }
      })
      setSendMailStatus(null)
    }
  }, [sendMailStatus])

  useEffect(() => {
    const socket = initializeSocket();

    socket.on('paymentSuccess', (data) => {
      console.log('Payment Success Event:', data);
      setOpenDialogQr(false);
    });

    return () => {
      socket.off('paymentSuccess');
      disconnectSocket();
    };
  }, []);
  return (
    <div>
      <Loading isLoading={isLoading} />
      <div>
        <div className="px-2 mt-6 ">
          <div>
            <div>
              {/* Desktop view */}
              <Grid
                container
                spacing={2}
                sx={{
                  display: { xs: 'none', sm: 'none', md: 'none', lg: 'flex' },
                }}
              >
                {/* Your table component here */}
                <TableContainer sx={{ overflowX: 'auto', minWidth: 650 }} component={Paper}>

                  <LinearLoading isLinearLoading={isLinearLoading} />
                  <Table size="small" stickyHeader aria-label="sticky table">
                    <TableHead>
                      <TableRow>
                        <TableCell align="center">
                          <Checkbox
                            checked={isCheckboxAllChecked}
                            onChange={(e) => handleSelectAllRows(e)}
                          />
                        </TableCell>
                        <TableCell align="left" >เลขที่ใบแจ้งหนี้</TableCell>
                        <TableCell align="center" >ชื่อผู้ใช้บริการ</TableCell>
                        <TableCell align="center" >รายการ</TableCell>
                        <TableCell align="center" >
                          เลขอ้างอิงคำสั่งรับเงิน
                        </TableCell>
                        <TableCell>
                          <TableSortLabel
                            active={sort.column === 'inv_start_date'}
                            direction={sort.direction || 'asc'}
                            onClick={() => handleSort('inv_start_date')}
                          >
                            วันที่ซื้อ
                          </TableSortLabel>
                        </TableCell>

                        <TableCell >
                          <TableSortLabel
                            active={sort.column === 'due_date'}
                            direction={sort.direction || 'asc'}
                            onClick={() => handleSort('due_date')}
                          >
                            วันที่ครบชำระ
                          </TableSortLabel>
                        </TableCell>

                        {/* <TableCell >
                          <TableSortLabel
                            active={sort.column === 'createdAt'}
                            direction={sort.direction || 'asc'}
                            onClick={() => handleSort('createdAt')}
                          >
                            วันที่สร้างรายการ
                          </TableSortLabel>
                        </TableCell> */}
                        <TableCell align="center" sx={{ maxWidth: 60 }} >สถานะ</TableCell>
                        <TableCell align="right" >
                          <TableSortLabel
                            active={sort.column === 'total_amount'}
                            direction={sort.direction || 'asc'}
                            onClick={() => handleSort('total_amount')}
                          >
                            จำนวนเงิน
                          </TableSortLabel>
                        </TableCell>
                        <TableCell align="center" >
                          ส่งอีเมลแจ้งค่าใช้บริการ
                        </TableCell>
                        {/* <TableCell align="center">รายละเอียด</TableCell> */}
                        <TableCell align="center" >ช่องทาง</TableCell>
                        <TableCell align="center" >ลบรายการ</TableCell>
                        <TableCell align="center">เพิ่มเติม</TableCell>
                      </TableRow>
                    </TableHead>
                    {_.size(invoiceList) ? (
                      <TableBody>
                        {invoiceList.map((row, index) => (
                          <TableRow
                            key={index}
                            sx={{
                              '&:last-child td, &:last-child th': { border: 0 },
                            }}
                            // onClick={(event) => {
                            //   console.log('index', index);
                            //   console.log(row);
                            // }}
                          >
                            <TableCell align="center">
                              <Checkbox
                                // checked={selectedRows.includes(row)}
                                // onClick={() => handleRowClick(row)}
                                checked={isSelected(row._id)}
                                onChange={() => handleSelectRow(row)}
                              />
                            </TableCell>
                            <TableCell align="left">{row.invoice_no}</TableCell>
                            <TableCell align="center">{row.so_name}</TableCell>
                            <TableCell align="center">
                              {row.descriptions}
                            </TableCell>
                            <TableCell>{row.order_id}</TableCell>
                            <TableCell>
                              {dayjs(row.inv_start_date).format('YYYY-MM-DD')}
                            </TableCell>
                            <TableCell>
                              {dayjs(row.inv_due_date).format('YYYY-MM-DD')}
                            </TableCell>
                            {/* <TableCell>
                              {dayjs(row.createdAt).format('YYYY-MM-DD')}
                            </TableCell> */}
                            <TableCell sx={{ width: 100 }}>
                              <Box
                                sx={
                                  row.isLate
                                    ? styleStatusNoLate
                                    : styleStatusLate
                                }
                              >
                                {row.isLate ? 'ยังไม่เกินกำหนด' : 'เกินกำหนด'}
                              </Box>
                            </TableCell>

                            <TableCell align="right">
                              {addCommas(row.amount, 2)}
                            </TableCell>
                            <TableCell align="center">
                              <Button
                                sx={{ color: '#fff', minWidth: '100%' }}
                                color={ MAIL_BUTTON[row.send_mail_status].color }
                                variant="contained"
                                endIcon={ MAIL_BUTTON[row.send_mail_status].icon }
                                disabled={!row?.email || MAIL_BUTTON[row.send_mail_status].disabled}
                                id={row.value}
                                loading={isLoading.toString()}
                                onClick={() => {
                                  handleOpenEmailDialog([row]);
                                }}
                              >
                                { MAIL_BUTTON[row.send_mail_status].label }
                              </Button>
                            </TableCell>
                            {/* <TableCell align="center">
                            {' '}
                            <IconButton
                              onClick={(event) => {
                                console.log('index', index);
                                console.log(row);
                                setOpenDetail(true);
                              }}
                            >
                              <VisibilityIcon sx={{ color: '#4FA893' }} />
                            </IconButton>
                          </TableCell> */}

                            <TableCell align="center">
                              {havePdf && (
                              <Tooltip title="ดู Invoice" arrow>
                                <span>
                                  <IconButton
                                    onClick={() => {
                                      handlePreviewPdf(row.order_id);
                                    }}
                                  >
                                    <PictureAsPdfIcon sx={{
                                      color: '#4FA893'
                                      }}
                                    />
                                  </IconButton>
                                </span>
                              </Tooltip>
                              )}

                              <Tooltip title="คัดลอกลิงก์" arrow>
                                  <IconButton
                                    disabled={!row.amount}
                                    onClick={() => {
                                      copyTextToClipboard(row._id);
                                    }}
                                  >
                                    <FileCopyIcon sx={{ color: !row.amount ? '' : '#4FA893' }} />
                                  </IconButton>
                              </Tooltip>
                              {/* {row?.invoice_transaction?._id ? ( */}
                              <Tooltip title="ดู QR Code" arrow>
                                <IconButton
                                  disabled={row.ops_type === 'NO' || !row.amount || NoQrCode}
                                  onClick={() => handleShowQrCode(row._id)}
                                >
                                  <QrCode2Icon
                                    color={
                                      row.ops_type === 'NO' ? '' : 'primary' &&
                                      !row.amount ? '' : 'primary' &&
                                      NoQrCode ? '' : 'primary'
                                    }
                                  />
                                </IconButton>
                              </Tooltip>
                              {/* // ) : (
                            //   <Tooltip title="ดาวน์โหลด QR" arrow>
                            //     <IconButton disabled>
                            //       <QrCode2Icon />
                            //     </IconButton>
                            //   </Tooltip>
                            // )} */}
                            </TableCell>
                            <TableCell align="center">
                              <Tooltip title="ลบรายการ" arrow>
                                <IconButton
                                  onClick={() => {
                                    handleDeleteInv(row._id);
                                  }}
                                >
                                  <DeleteIcon color="error" />
                                </IconButton>
                              </Tooltip>
                            </TableCell>
                            {/* ปุ่มแสดงเมนู */}
                            <TableCell>
                              <Tooltip title='เมนูเพิ่มเติม' arrow>
                                <span>
                                  <IconButton
                                    onClick={(event) => {
                                      handleMenu(event);
                                      setMenuRowOrderId(row.order_id);
                                    }}
                                    aria-controls={open ? 'account-menu' : undefined}
                                    aria-haspopup="true"
                                    aria-expanded={open ? 'true' : undefined}
                                  >
                                    <MoreHorizIcon color="primary" />
                                  </IconButton>
                                </span>
                              </Tooltip>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    ) : (
                      <TableBody>
                        <TableRow>
                          <TableCell colSpan={14} align="center">
                            <div>ไม่มีข้อมูล</div>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    )}
                  </Table>
                  <TablePagination
                    rowsPerPageOptions={ITEM_PER_PAGE}
                    component="div"
                    rowsPerPage={rowsPerPage}
                    page={page}
                    count={total}
                    onPageChange={(event, newPage) => {
                      setPage(newPage);
                    }}
                    onRowsPerPageChange={(event) => {
                      setRowsPerPage(parseInt(event.target.value, 10));
                      setPage(0);
                    }}
                  />
                </TableContainer>
              </Grid>

              {/* Mobile/Tablet view */}
              <Grid
                container
                spacing={2}
                sx={{
                  display: { xs: 'flex', sm: 'flex', md: 'flex', lg: 'none' },
                }}
              >
                {invoiceList.map((row, index) => (
                  <Grid item xs={16} md={6} key={index}>
                    <Card sx={{ height: '100%' }}>
                      <Grid item xs={12} sx={{ paddingBottom: 0 }}>
                        <Box
                          sx={
                            row.isLate
                              ? styleStatusNoLateCard
                              : styleStatusLateCard
                          }
                        >
                          {row.isLate ? 'ยังไม่เกินกำหนด' : 'เกินกำหนด'}
                        </Box>
                      </Grid>
                      <CardHeader
                        title={row.invoice_no}
                        subheader={row.so_name}
                        action={
                          <Checkbox
                            checked={isSelected(row._id)}
                            onChange={() => handleSelectRow(row)}
                          />
                        }
                      />
                      <CardContent sx={{ paddingTop: 0 }}>
                        <Grid container spacing={2}>
                          <Grid item xs={6}>
                            <Typography variant="body2" color="textSecondary">
                              รายการ:
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography
                              variant="body2"
                              sx={{ textAlign: 'right' }}
                            >
                              {row.descriptions}
                            </Typography>
                          </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                          <Grid item xs={6}>
                            <Typography variant="body2" color="textSecondary">
                              เลขอ้างอิงคำสั่งรับเงิน:
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography
                              variant="body2"
                              sx={{ textAlign: 'right' }}
                            >
                              {row.order_id}
                            </Typography>
                          </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                          <Grid item xs={6}>
                            <Typography variant="body2" color="textSecondary">
                              วันที่ใบสั่งซื้อ:{' '}
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography
                              variant="body2"
                              sx={{ textAlign: 'right' }}
                            >
                              {dayjs(row.inv_start_date).format('YYYY-MM-DD')}
                            </Typography>
                          </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                          <Grid item xs={6}>
                            <Typography variant="body2" color="textSecondary">
                              วันที่ครบชำระ:{' '}
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography
                              variant="body2"
                              sx={{ textAlign: 'right' }}
                            >
                              {dayjs(row.inv_due_date).format('YYYY-MM-DD')}
                            </Typography>
                          </Grid>
                        </Grid>
                        {/* <Grid container spacing={2}>
                          <Grid item xs={6}>
                            <Typography variant="body2" color="textSecondary">
                              วันที่สร้างรายการ:{' '}
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography
                              variant="body2"
                              sx={{ textAlign: 'right' }}
                            >
                              {dayjs(row.createdAt).format('YYYY-MM-DD')}
                            </Typography>
                          </Grid>
                        </Grid> */}
                        <Grid container spacing={2}>
                          <Grid item xs={6}>
                            <Typography variant="body2" color="textSecondary">
                              จำนวนเงิน:
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography
                              variant="body2"
                              sx={{ textAlign: 'right' }}
                            >
                              {addCommas(row.amount, 2)}
                            </Typography>
                          </Grid>
                        </Grid>
                      </CardContent>
                      <CardContent
                        sx={{
                          display: 'flex',
                          justifyContent: 'space-between',
                        }}
                      >
                        <span>
                          <IconButton
                            sx={{
                              backgroundColor: row.send_mail_status === 'none' ? '#4FA893' : row.send_mail_status === 'sent' ? '#f9a825' : '#ee2425',
                              color: '#FFFFFF',
                              borderRadius: '4px',
                              width: '100px',
                            }}
                            variant="contained"
                            id={row.value}
                            loading={isLoading.toString()}
                            disabled={!row?.email}
                            onClick={() => {
                              handleOpenEmailDialog([row]);
                            }}
                          >
                            {row?.send_mail_status ? (
                              <ReplayIcon />
                            ) : (
                              <SendIcon />
                            )}
                          </IconButton>
                        </span>
                        {havePdf && (
                        <Tooltip title="ดู invoice" arrow>
                          <span>
                            <IconButton
                              onClick={() => handlePreviewPdf(row.order_id)}
                            >
                              <PictureAsPdfIcon sx={{
                                color: '#4FA893'
                              }} />
                            </IconButton>
                          </span>
                        </Tooltip>
                        )}

                        <Tooltip title="คัดลอกลิงก์" arrow>
                          <IconButton
                            disabled={!row.amount}
                            onClick={() => copyTextToClipboard(row._id)}
                          >
                            <FileCopyIcon sx={{  color: !row.amount ? '' : '#4FA893' }} />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="ดู QR Code" arrow>
                          <IconButton
                            disabled={row.ops_type === 'NO' || !row.amount || NoQrCode}
                            onClick={() => handleShowQrCode(row._id)}>
                            <QrCode2Icon
                              color={
                                row.ops_type === 'NO' ? '' : 'primary' &&
                                !row.amount ? '' : 'primary' && 
                                NoQrCode ? '' : 'primary'
                              } />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Delete" arrow>
                          <span>
                            <IconButton
                              onClick={() => handleDeleteInv(row._id)}
                            >
                              <DeleteIcon color="error" />
                            </IconButton>
                          </span>
                        </Tooltip>

                        <Tooltip title='ยืนยันการรับชำระเงิน' arrow>
                          <span>
                            <IconButton
                              onClick={(event) => {
                                handleMenu(event);
                                setMenuRowOrderId(row.order_id);
                              }}
                              aria-controls={open ? 'account-menu' : undefined}
                              aria-haspopup="true"
                              aria-expanded={open ? 'true' : undefined}
                            >
                              <MoreHorizIcon color="primary" />
                            </IconButton>
                          </span>
                        </Tooltip>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
                <Grid
                  item
                  md={12}
                  sx={{ justifyContent: 'center', display: 'flex' }}
                >
                  <TablePagination
                    id="pagination-dropdown"
                    sx={{
                      width: 'auto',
                      marginRight: '8px',
                      '& .MuiTypography-caption': { display: 'none' },
                    }}
                    rowsPerPageOptions={ITEM_PER_PAGE}
                    component="div"
                    rowsPerPage={rowsPerPage}
                    page={page}
                    count={total}
                    labelRowsPerPage="Rows"
                    onPageChange={(event, newPage) => {
                      setPage(newPage);
                    }}
                    onRowsPerPageChange={(event) => {
                      setRowsPerPage(parseInt(event.target.value, 10));
                      setPage(0);
                    }}
                  />
                </Grid>
              </Grid>
            </div>
          </div>
          <div className='mt-6'>
            <Stack
              direction={{ xs: 'column', md: 'row' }}
              spacing={2}
              justifyContent={{ xs: 'center', md: 'flex-end' }}
              sx={{ width: '100%' }}
            >
              <Button sx={{ color: '#fff' }} color="error" variant="contained" endIcon={<DeleteIcon />} onClick={() => {handleDeleteALL()}}>
                ลบทั้งหมด {selectedRows.length} รายการ
              </Button>
              {havePdf && (
                <Button sx={{ color: '#fff' }} color="info" variant="contained" endIcon={<DownloadForOfflineIcon />} onClick={() => {handleDownloadZipPDF(selectedRows)}}>
                  ดาวน์โหลด PDF {selectedRows.length} รายการ
                </Button>
              )}
              <Button sx={{ color: '#fff' }} variant="contained" endIcon={<SendIcon />} loading={isLoading.toString()} onClick={() => {handleOpenEmailDialog(selectedRows)}}>
                ส่งทั้งหมด {selectedRows.length} รายการ
              </Button>
            </Stack>
          </div>
        </div>
      </div>
      <div>
        <DetailPayment setOpenDetail={setOpenDetail} openDetail={openDetail} />
      </div>
      <QrCodeDialog
        openDialogQr={openDialogQr}
        setOpenDialogQr={setOpenDialogQr}
        qrCode={qrCode}
      />

      <PreviewPdfDialog
        openDialogPDF={openDialogPDF}
        setOpenDialogPDF={setOpenDialogPDF}
        handleDownloadPdf={handleDownloadPdf}
        showPdf={showPdf}
      />

      <ManualPaidDialog
        open={openDialogConfirmBarcode}
        onClose={handleCancel}
        selectedDueDate={selectedDueDate}
        selectedDate={selectedDate}
        selectedTime={selectedTime}
        inputError={inputError}
        setSelectedDueDate={setSelectedDueDate}
        setSelectedTime={setSelectedTime}
        setInputError={setInputError}
        handleConfirmBarCode={handleConfirmBarCode}
        handleCancel={handleCancel}
      />

      <DetailDialog
        open={openDialogDetail}
        onClose={closeDetailDialog}
        detailData={detailData}
      />

      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleCloseMenu}
        onClick={handleCloseMenu}
        slotProps={{
          list: {
            'aria-labelledby': 'account-menu',
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        { manualPayment && (
          <MenuItem onClick={() => {
              setSelectedOrderId(menuRowOrderId);
              openDialogConfirm();
            }}
            style={{ gap: '8px' }}
          >
            <VerifiedIcon color='primary' /> ยืนยันการชำระเงิน
          </MenuItem>
        )}

        <MenuItem onClick={() => { openDetailDialog(menuRowOrderId) }} style={{ gap: '8px' }}>
          <VisibilityIcon color='primary'/> ดูรายละเอียด
        </MenuItem>
      </Menu>

      {rowSelectedList.length > 0 && (
        <EmailConfirmDialog
          open={openDialogEmail}
          onClose={closeDialogEmail}
          rowSelectedList={rowSelectedList}
          setSendMailStatus={setSendMailStatus}
        />
      )}
    </div>
  );
}

export default TableInvoiceList;
